import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/i18n/LanguageContext';
import SEO from '../components/SEO';
import Button from '../components/ui/Button';

const NotFound = () => {
  const { t } = useLanguage();

  useEffect(() => {}, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="min-h-[80vh] flex flex-col items-center justify-center py-20"
    >
      <SEO
        title={`${t.notFound.title} | Rossopomodoro`}
        description="Page not found at Rossopomodoro Reykjavik. Return to our homepage or explore our authentic Italian menu. Best pizza & pasta in downtown Reykjavik."
        canonical="https://rossopomodoro.is/404"
        noIndex={true}
      />
      <div className="container-custom text-center">
        <div className="mb-8">
          <img
            src="https://images.pexels.com/photos/10181446/pexels-photo-10181446.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&dpr=1"
            srcSet="https://images.pexels.com/photos/10181446/pexels-photo-10181446.jpeg?auto=compress&cs=tinysrgb&w=200&dpr=1 200w, https://images.pexels.com/photos/10181446/pexels-photo-10181446.jpeg?auto=compress&cs=tinysrgb&w=400&dpr=1 400w"
            sizes="(max-width: 640px) 128px, 160px"
            alt="Delicious pizza slice from Rossopomodoro Reykjavik - best Italian restaurant in downtown Reykjavik"
            title="Authentic Neapolitan pizza at Rossopomodoro Reykjavik"
            loading="lazy"
            width="160"
            height="160"
            className="w-32 sm:w-40 h-32 sm:h-40 object-cover rounded-full mx-auto border-4 border-red-800"
          />
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-neutral-900 mb-4">
          {t.notFound.title}
        </h1>
        <p className="font-serif text-xl sm:text-2xl lg:text-3xl font-semibold text-neutral-700 mb-6">
          {t.notFound.heading}
        </p>
        <p className="text-neutral-600 max-w-md mx-auto mb-8 text-base leading-relaxed">
          {t.notFound.description}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button variant="primary">{t.notFound.buttons.home}</Button>
          </Link>
          <Link to="/menu">
            <Button variant="secondary">{t.notFound.buttons.menu}</Button>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default NotFound;
